export const ARTICLE_CONTENT_UPDATE_DELAY = 200
export const ARTICLE_SAVE_DELAY = ARTICLE_CONTENT_UPDATE_DELAY + 10
